import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import EdgeFunctionDebugger from '@/components/agent/debug/EdgeFunctionDebugger';
import PageHeader from '@/components/layout/PageHeader';

const EdgeFunctionDebug = () => {
  return (
    <MainLayout>
      <PageHeader title="Edge Function Debugger" />
      <div className="px-6 py-6 w-full">
        <EdgeFunctionDebugger />
      </div>
    </MainLayout>
  );
};

export default EdgeFunctionDebug;
